import qs from 'qs';
import client from './client';

const commonCodeUrl = '/api/v1/project/invoice';

//코드 리스트 가져오기
export const getpurchaseMaintenanceList = (searchData) =>{
  const queryString = qs.stringify(searchData);
  return client.get(`${commonCodeUrl}/purchase/plan/list?${queryString}`);
}

export const updatePurchaseMaintenanceBulk = (updateData) => {
  return client.post(`${commonCodeUrl}/purchase/batch`, updateData);
};

// 검수 완료 업데이트 (추가 코드)
export const updatePurchaseMaintenance = (updateData) => {
  return client.put(`${commonCodeUrl}/plan/info`, updateData);
};


//코드 추가
export const addComCode = (dataToSubmit) => {
  return client.post(`${commonCodeUrl}/info`, dataToSubmit);
};

//코드 정보
export const getCode = (id) => client.get(`${commonCodeUrl}/info/${id}`);

export const editCode = (id, dataToSubmit) => {
  return client.put(`${commonCodeUrl}/info/${id}`, dataToSubmit);
};

//코드 삭제
export const removeCode = (id) => client.delete(`${commonCodeUrl}/info/${id}`);
